import React, { FunctionComponent } from 'react';
import {
  Distance,
  DistanceUnit,
  Duration,
  Steps,
  TimeUnit,
} from '../../../types/__generated__';
import { FormattedDistance } from './FormattedDistance';
import { FormattedDuration } from './FormattedDuration';

export type FormattedMeasurementProps = {
  measurement: Distance | Duration | Steps;
};

export const FormattedMeasurement: FunctionComponent<FormattedMeasurementProps> = ({
  measurement,
}) => {
  switch (measurement.unit) {
    case DistanceUnit.Feet:
    case DistanceUnit.Metres:
      return <FormattedDistance value={measurement as Distance} />;
    case TimeUnit.Milliseconds:
    case TimeUnit.Seconds:
      return <FormattedDuration value={measurement as Duration} />;
    default:
      return (
        <span>{measurement.value + ' ' + measurement.unit.toLowerCase()}</span>
      );
  }
};
